import SuccessMessage from "@/components/SuccessMessage/SuccessMessage.vue"

export default {
   name: 'ClientEmailConfirm',
   components: {SuccessMessage},
   data() {
      return {
         validToken: false,
      }
   },
   created() {
      this.check()
   },
   methods: {
      check() {
         this.$store.dispatch('proved', this.$route.params.token).then(res => {
            if (res.status == 200) {
               this.validToken = true
            }
         })
      }
   }
}